module.exports = __webpack_public_path__ + "public/img/house.25877370.png";